import './Loader.css';

const Loader = () => {

  return (
    // loader
    <div className='loader-container'>
      <div className="rounded-loader"></div>
    </div>

  );
};

export default Loader;
